<ng-container *ngIf="loading"> 
  <div class="container-with-loading">
      <div class="loading-overlay">
          <mat-spinner></mat-spinner>
      </div>
  </div>
</ng-container>
<div class="login-wrapper">
<!--div class ="card"-->
  <mat-card class="card-body" appearance="outlined" [hidden]="loading">
    <mat-card-header class='headerCard'>
      <mat-card-title>
        <mat-icon>account_circle</mat-icon>Recupera tu cuenta
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="contendCard">
      <div class="contend">
        <form [formGroup]="form">
          <div class="mb-3">
            <mat-form-field class="controlHeight">
              <mat-label>Correo electr&oacute;nico</mat-label>
              <input id="email" type="email" matInput
              placeholder="ejemplo@correo.com" formControlName="email" readonly />
            </mat-form-field>
          </div>
          <div class="mb-3">
            <mat-form-field class="controlHeight">
              <mat-label>Nueva Contraseña</mat-label>
              <input id="password" type="password" matInput formControlName="password" autocomplete="new-password" required />
            </mat-form-field>
          </div>
          <div class="mb-3">
            <mat-form-field class="controlHeight">
              <mat-label>Confirma Contraseña</mat-label>
              <input id="confirmPassword" type="password" matInput formControlName="confirmPassword" autocomplete="new-password" required/>
            </mat-form-field>
            <div *ngIf="form.hasError('passwordsMismatch') && form.get('confirmPassword')?.touched">
	            Las contraseñas no coinciden
	        </div>
          </div>
        </form>
      </div>
    </mat-card-content>
    <mat-card-actions class="contendCard">
      <div >
        <button mat-flat-button class="button controlHeight" (click) ='onSubmit()'><mat-icon>lock_reset</mat-icon>Guardar Contraseña</button>
      </div>
    </mat-card-actions>
    <mat-card-actions class="contendCard">
      <div >
        <button mat-flat-button class="button controlHeight" (click) ='onCancel()'><mat-icon>cancel</mat-icon>Cancelar</button>
      </div>
    </mat-card-actions>
    <!--mat-card-actions>
      <div class="formControl?">
        <div class="control">
          <button mat-flat-button class="button controlHeight" (click) ='onSubmit()'>
            <mat-icon>lock_reset</mat-icon>Guardar Contraseña</button>
        </div>
        <div class="control">
          <button mat-flat-button class="button controlHeight padingLogin" (click) ='onCancel()'>
            <mat-icon>cancel</mat-icon>Cancelar</button>
        </div>
      </div>
    </mat-card-actions-->
  </mat-card>
</div>